module.exports = require("url-parse");


//////////////////
// WEBPACK FOOTER
// external "url-parse"
// module id = 535
// module chunks = 0